export const brand = [
  {
    domain: ['fanli.taokeruanjianjd.com'],
    title: '淘客软件基地',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/fanli_taokeruanjianjd_com.png',
    copyright: '淘客软件基地@念初网络',
    im_app: '',
    download_app: 'https://www.yuque.com/docs/share/35dac632-7fe1-4cf4-bb19-dab3e439b858',
    spread: true,
    demo_alert: true,
    independent: false,
    invitation_code: '',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['www.tcjzqsq.cn'],
    title: '八爪鱼', // 淘聚臣
    describe: '云控返利机器人',
    logo: 'https://nianchu-robot-yun-resource.oss-cn-hongkong.aliyuncs.com/brand-oem/bzywtk_cn.png',
    copyright: '八爪鱼',
    im_app: '',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/BaZHuaYu_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'TJCVIP',
    basic_teaching: '',
    menu_fentu_hidden: true,
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.yitk.net'],
    title: '易淘返利系统',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_yitk_net.png',
    copyright: '易淘',
    im_app: 'http://im.nianchu.net/',
    download_app: '',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'YT8888',
    basic_teaching: 'http://yitk.net/',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['dl.huofen.net'],
    title: '火粉软件',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/dl_huofen_net.png',
    copyright: '火粉软件',
    im_app: '',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/HuoFen_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'D3866D',
    basic_teaching: '',
    is_custom_cash: true,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['spk.51shanhe.com'],
    title: 'Shanhe Cloud',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/spk_51shanhe_com.png',
    copyright: '卓越金服',
    im_app: 'http://im.51shanhe.com',
    download_app: '',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'SHANHE',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.yunmiaoke.com'],
    title: '云喵',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_yunmiaoke_com.png',
    copyright: '云喵电商',
    im_app: 'http://im.yunmiaoke.com/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/YunMiao_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'YUN666',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.bfk001.cn'],
    title: '捕风飞扬',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_bfk001_cn.png',
    copyright: '捕风客网络',
    im_app: 'http://im.bfk001.cn/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/BFK_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'BFK123',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.cainiaofanli.com'],
    title: '菜鸟返利',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_cainiaofanli_com.png',
    copyright: '菜鸟返利',
    im_app: 'http://im.nianchu.net/',
    download_app: 'https://www.yuque.com/docs/share/35dac632-7fe1-4cf4-bb19-dab3e439b858',
    spread: true,
    demo_alert: true,
    independent: true,
    menu_fentu_hidden: false,
    invitation_code: '',
    basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.yunketang.plus'],
    title: '云课堂',
    describe: '云课堂演示后台',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_yunketang_plus.png',
    copyright: '云课堂',
    im_app: 'http://im.yunketang.plus/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/YunKeTang_WeChat_Robot_Cloud.zip',
    spread: true,
    demo_alert: true,
    independent: true,
    menu_fentu_hidden: false,
    invitation_code: '',
    basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.nianchu.cloud'],
    title: '念初·虎哥',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_nianchu_cloud.png',
    copyright: '念初网络',
    im_app: 'http://im.nianchu.net/',
    download_app: 'https://www.yuque.com/docs/share/35dac632-7fe1-4cf4-bb19-dab3e439b858',
    spread: false,
    demo_alert: true,
    independent: false,
    menu_fentu_hidden: false,
    invitation_code: '',
    basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.siyubao.net'],
    title: '私域宝',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_siyubao_net.png',
    copyright: '私域宝',
    im_app: 'http://im.siyubao.net/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/SiYuBao_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'SYB666',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.jinniuke888.cn'],
    title: '金牛',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_jinniuke888_cn.png',
    copyright: '金牛返利',
    im_app: 'http://im.jinniuke888.cn/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/JinNiu_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: '222666',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.nianchufanli.com'],
    title: '念初云端版',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_nianchufanli_com.png',
    copyright: '念初云端版',
    im_app: 'http://im.nianchufanli.com/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/NianChuYunDuanBan_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'nian00',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.cstars.net'],
    title: '繁星淘客',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_cstars_net.png',
    copyright: '繁星淘客',
    im_app: 'http://im.cstars.net/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/FanXingTaoKe_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'fxtk00',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['bzywtk.cn'],
    title: '八爪鱼',
    describe: '云控返利机器人',
    logo: 'https://nianchu-robot-yun-resource.oss-cn-hongkong.aliyuncs.com/brand-oem/bzywtk_cn.png',
    copyright: '八爪鱼',
    im_app: 'http://im.bzywtk.cn/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/BaZHuaYu_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'VIP888',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.mengkekeji.cn'],
    title: '梦科科技',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_mengkekeji_cn.png',
    copyright: '梦科科技',
    im_app: 'http://kf.mengkekeji.cn/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/MengKe_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: '888888',
    basic_teaching: '',
    is_custom_cash: false,
    extend: ['HidePluginEntrance', 'HideBanner', 'HideBattle'],
    extend_data: {},
  },
  {
    domain: ['yun.chaojisheng.net'],
    title: '超级省',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_chaojisheng_net.png',
    copyright: '超级省',
    im_app: 'http://im.chaojisheng.net/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/ChaoJiShen_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'ctw888',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [
      'UseDataBase',
      'UseServer',
      'HidePluginEntrance',
      'HideWorkplace',
      'HideMoney',
      'HidePlugin',
      'HideBasic',
      'HideDialogue',
      'HideQuestions',
      'HideMore',
      'HideLogo',
      'HideLc',
      'HideRebateSettings',
    ],
    extend_data: {},
  },
  {
    domain: ['yun.fhnaw.store'],
    title: '领业网络',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_fhnaw_store.png',
    copyright: '河北领业网络科技有限公司',
    im_app: 'http://im.fhnaw.store/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/LingYeWangLuo_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'LYWLKJ',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
  {
    domain: ['yun.yezisoft.cn'],
    title: '云管理平台',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/yun_yezisoft_cn.png',
    copyright: '叶子联盟',
    im_app: 'http://im.yezisoft.cn/',
    download_app: 'https://yezi-1302760117.cos.ap-shanghai.myqcloud.com/download/YeZi_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: '123456',
    basic_teaching: 'https://www.yuque.com/yztaoke/share',
    is_custom_cash: false,
    extend: [
      'CustomerServiceDrawer',
      'CustomerUpdateLog',
      'CustomerNeeds',
      'CustomerService',
      'HideBanner',
      'HidePluginEntrance',
      'HideToken',
    ],
    extend_data: {
      customerService: {
        url: 'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97807251ce2542cfec1bb3b6661060e96101584feda9553cb6ec3b583482ff0c0950b1c581ae3e5514b572c0b9dca10c68',
      },
      customerUpdateLog: {
        url: 'https://www.yezisoft.cn/update',
      },
      customerNeeds: {
        url: 'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97807251ce2542cfec1bb3b6661060e96101584feda9553cb6ec3b583482ff0c0950b1c581ae3e5514b572c0b9dca10c68',
      },
    },
  },
  {
    domain: ['www.jiujiuwangluo.cn'],
    title: '菲喵超省',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/www_jiamiwangluo_com.png',
    copyright: '九久网络',
    im_app: 'http://im.jiujiuwangluo.cn/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/FeiMiaoChaoShen__WeChat_Robot_Cloud_Mod.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'feimiao',
    basic_teaching: '',
    is_custom_cash: false,
    //extend: ['UseDataBase', 'HideWorkplace', 'HideFree', 'HideBug', 'HidePluginEntrance', 'HideLcDesc', 'HideLogo'],
    extend:[],
    extend_data: {},
  },
  {
    domain: ['i.yituiyun.com'],
    title: '运营商平台',
    describe: '云控返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/i_yituiyun_com.png',
    copyright: '易推云',
    im_app: 'http://im.yituiyun.com/',
    download_app: 'https://www.yuque.com/yituiyun/list/download',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: '000000',
    basic_teaching: '',
    is_custom_cash: false,
    extend: ['HideBanner', 'CustomerUpdateLog', 'BuyCamille'],
    extend_data: {
      customerUpdateLog: {
        url: 'https://www.yuque.com/yituiyun/list',
        title: '平台使用教程',
      },
      buyCamille: {
        url: 'https://www.yuque.com/yituiyun/buy/ka',
        title: '购买卡密',
      },
    },
  },
  {
    domain: ['f.xiaohuangya.com'],
    title: '小黄鸭',
    describe: '小鸭返利机器人',
    logo: 'https://yun-resource.nianchu.net/brand-oem/xiaohuanya_com.png',
    copyright: '易火科技',
    im_app: 'http://im.yituiyun.com/',
    download_app: 'https://ncnk-oem.oss-cn-beijing.aliyuncs.com/XiaoYa_WeChat_Robot_Cloud.zip',
    spread: false,
    demo_alert: false,
    independent: true,
    invitation_code: 'D95D25',
    basic_teaching: '',
    is_custom_cash: false,
    extend: [],
    extend_data: {},
  },
	{
	  domain: ['nianchu.dgrlm.com'],
	  title: '打工人联盟',
	  describe: '打工人联盟',
	  logo: 'https://yun-resource.nianchu.net/brand-oem/dagongrenlianmeng_com.png.png',
	  copyright: '打工人联盟',
	  im_app: 'http://yun.chuyukefu.net/',
	  download_app: 'http://zjzd.nianchu.net/thread/266',
	  spread: true,
	  demo_alert: true,
	  independent: false,
	  invitation_code: 'dgr888',
	  basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
	  is_custom_cash: false,
	  extend: [
		  'HideCompanyTaobao',
		  'HideCompanyJingyong',
		  'HideCompanyPinduoduoList',
		  'HideCompanyDxzList',
		  'HideCompanyWeipinhuiList',
		  'HideOrder-newTaobao',
		  'HideOrder-newPinduoduo',
		  'HideOrder-newWeipinhui'
	  ],
	  extend_data: {},
	},
]

export const defaultBrand = {  
  title: 'Nianchu Cloud v3.0',
  describe: '全链路粉丝运营变现解决方案',
  logo: 'https://yun-resource.nianchu.net/brand-oem/yun_nianchu_net.png',
  copyright: '念初网络-NianchuCloud项目组',
  // im_app: 'http://im.nianchu.net/',
  im_app: 'http://yun.chuyukefu.net/',
  download_app: 'http://zjzd.nianchu.net/thread/266',
  spread: true,
  demo_alert: true,
  independent: false,
  invitation_code: '',
  menu_fentu_hidden: false,
  basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
  is_custom_cash: false,
  extend: ['CustomerServiceDrawer', 'UseForum'],
  extend_data: {},
}

// （标题）title: 'Nianchu Cloud',
// （标志）logo: '',
// （版权）copyright: '念初网络',
// （客服系统地址）im_app: 'https://im.nianchu.net/',
// （下载地址）download_app: 'https://www.yuque.com/docs/share/35dac632-7fe1-4cf4-bb19-dab3e439b858',
// （是否打开推广）spread: true,
// （是否显示教程视频）demo_alert: true,
// （是否独立、续费）independent: false,
// （邀请码）invitation_code: '',
// （是否隐藏粉兔菜单）menu_fentu_hidden: false,
// （新手教学文档）basic_teaching: 'https://www.yuque.com/books/share/6e3b85df-dbd1-4b6c-8d21-f5e2c95dc082#',
// （是否自定义提现平台）is_custom_cash: false
// （扩展）extend: [],
//  (拓展数据) extend_data: {}
